<!-- 🚀 CANDADO DE ARQUITECTURA: Desactiva por completo la caché de hidratación de Angular SSR -->
<div ngSkipHydration>

  <div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
    
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">Ecosistema Global de Catálogos (UDC)</h2>
        <span class="small text-muted font-monospace">JDE Global Settings System</span>
      </div>
      <button type="button" class="btn btn-primary btn-sm px-4 fw-bold shadow-sm" (click)="abrirAltaModal()" style="border-radius: 6px;">
        ➕ Nueva Clave Catálogo
      </button>
    </div>

    <!-- 🔍 Barra de Búsqueda Reactiva -->
    <div class="card mb-3 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        <div class="input-group input-group-sm">
          <span class="input-group-text bg-white border-end-0">🔍</span>
          <input type="text" class="form-control border-start-0 ps-0 text-uppercase" name="buscarUdc"
                 [(ngModel)]="filtroTexto" (input)="filtrarUdcs()" placeholder="Buscar clave por Código Sistema, Categoría o Descripción...">
        </div>
      </div>
    </div>

    <!-- 📊 Tabla de Datos -->
    <table class="table table-hover table-striped border shadow-sm align-middle">
      <thead class="table-dark">
        <tr>
          <th scope="col" style="width: 140px;">CÓDIGO SISTEMA</th>
          <th scope="col" style="width: 140px;">CATEGORÍA (KEY)</th>
          <th scope="col">DESCRIPCIÓN LARGA</th>
          <th scope="col" style="width: 120px;">VALOR 1</th>
          <th scope="col" style="width: 120px;">VALOR 2</th>
          <th scope="col" class="text-center" style="width: 100px;">ACCIONES</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let u of udcsPaginadas">
          <td class="font-monospace fw-bold text-primary">{{ u.udcSystem }}</td>
          <td class="font-monospace text-secondary fw-semibold">{{ u.udcKey }}</td>
          <td class="fw-semibold text-dark text-uppercase">{{ u.description }}</td>
          <td class="font-monospace text-muted">{{ u.strValue1 || '-' }}</td>
          <td class="font-monospace text-muted">{{ u.strValue2 || '-' }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-sm btn-info text-white fw-bold shadow-sm" (click)="abrirEdicionModal(u)">
              ✏️ Editar
            </button>
          </td>
        </tr>
        <tr *ngIf="udcsFiltradas.length === 0">
          <td colspan="6" class="text-center text-muted py-4">No se encontraron claves de catálogo en este perímetro.</td>
        </tr>
      </tbody>
    </table>

    <!-- 🎛️ BOTONERA ERGONÓMICA: BOTONES A LA IZQUIERDA Y LEYENDAS A LA DERECHA -->
    <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
      
      <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA (IZQUIERDA) -->
      <nav aria-label="Navegación de catálogos">
        <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
          
          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(1)" style="cursor: pointer;" title="Ir a la primera página">
              ⏮️ Primera
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
              ◀️ Anterior
            </button>
          </li>

          <li class="page-item disabled">
            <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
              PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
            </span>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
              Siguiente ▶️
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Ir a la última página">
              Última ⏭️
            </button>
          </li>

        </ul>
      </nav>

      <!-- 📊 RENDIMIENTO DE CONTEO Y LEYENDAS (DERECHA) -->
      <span class="text-muted small text-end">
        Mostrando registros del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
        al <strong>{{ Math.min(paginaActual * registrosPorPagina, udcsFiltradas.length) }}</strong> 
        de un total de <strong>{{ udcsFiltradas.length }}</strong> indexados.
      </span>

    </div>

  </div>

  <!-- ========================================================================= 
  // 🚀 INYECTADO: CONTENEDOR FLOTANTE RE-RENDEREADO DE TOASTS CORPORATIVOS
  // ========================================================================= -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
    <div *ngFor="let toast of toastService.toasts" 
         class="toast show shadow border-0 mb-2" 
         [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
         role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
        <strong class="me-auto d-flex align-items-center gap-2">
          <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </div>
      <div class="toast-body pt-0" style="font-size: 0.85rem;">
        {{ toast.text }}
      </div>
    </div>
  </div>

</div>